var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "area-selection" },
    [
      _c("custom-todo", {
        attrs: {
          draggable: "",
          "has-chip": "",
          "has-other": "",
          "has-pagination": "",
          icon: "fa-file-alt",
          "is-auto-select": "",
          "is-drop-down": "",
          "is-read-only": _vm.isReadOnly,
          label: "Diagnóstico del Estudiante:",
          options: _vm.availableDiagnosticsOptions,
          "search-settings": _vm.otherSettings,
          separator: _vm.isReadOnly ? "" : "Diagnósticos añadidos"
        },
        model: {
          value: _vm.localSelected,
          callback: function($$v) {
            _vm.localSelected = $$v
          },
          expression: "localSelected"
        }
      }),
      !_vm.isReadOnly
        ? _c(
            "div",
            { staticClass: "row mt-3 mr-1 d-flex justify-content-end" },
            [
              _vm.hasCancel
                ? _c("action-button", {
                    attrs: {
                      id: "btnCancel",
                      i: "fas fa-times-circle",
                      text: "Cancelar",
                      variant: "danger mr-2"
                    },
                    on: { click: _vm.onCancel }
                  })
                : _vm._e(),
              _c("action-button", {
                attrs: {
                  id: "btnAdd",
                  i: "fas fa-save",
                  text: "Guardar",
                  variant: "success"
                },
                on: { click: _vm.onSave }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }